export const Images = {
  loadingBlack: require('./loading60Black.svg'),
  loadingWhite: require('./loadingx43px.svg'),
};
